import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import * as actions from 'actions/index';
import loginSelector from 'selectors/login';
import Api from 'api';
import LoginComponent from '../components/Login';

const Login = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [loading, setLoading] = React.useState(false);
  const [requestedToken, setRequestedToken] = React.useState(false);
  const [requestedResetPassword, setRequestedResetPassword] = React.useState(false);
  const [showEmailConfirmation, setShowEmailConfirmation] = React.useState(false);

  const login = useSelector(loginSelector);

  const submitStepThree = async (username) => {
    await Api.sendAuthToken(username);

    setRequestedToken(true);
  };

  const submitStepOne = ({ username }) => {
    dispatch(
      actions.loginCheckUsername({
        username,
      }),
    );
  };

  const submitStepTwo = (data) => {
    const { username, password } = data;

    if (login.userType) {
      dispatch(actions.postLoginRequest({ username, password }));
    } else {
      // For new users, show email confirmation step first
      setShowEmailConfirmation(true);
    }
  };

  const submitEmailConfirmation = () => {
    // Email is validated in the component, so we can proceed to create user
    dispatch(actions.postCreateUserRequest({ username: login.username }));
  };

  const resetForm = (e) => {
    e.preventDefault();
    dispatch(actions.loginResetForm());
    setShowEmailConfirmation(false);
  };

  const resetPassword = async (body) => {
    const r = confirm(
      intl.formatMessage({
        // eslint-disable-line
        id: 'welcome.resetDialog',
        defaultMessage: 'Do you want us to send you a new password to your email? If Yes click OK',
      }),
    );

    if (r) {
      setLoading(true);

      try {
        await Api.requestResetPassword(body);

        setRequestedResetPassword(true);
      } catch (err) {
        dispatch(
          actions.showSnackbar({
            severity: 'error',
            message: {
              id: 'resetpassword.error',
              defaultMessage: 'Error',
            },
          }),
        );
      }

      setLoading(false);
    }
  };

  return (
    <LoginComponent
      submitStepOne={submitStepOne}
      submitStepTwo={submitStepTwo}
      submitStepThree={submitStepThree}
      submitEmailConfirmation={submitEmailConfirmation}
      requestedToken={requestedToken}
      login={login}
      resetForm={resetForm}
      resetPassword={resetPassword}
      requestedResetPassword={requestedResetPassword}
      loading={loading}
      showEmailConfirmation={showEmailConfirmation}
    />
  );
};

export default Login;
